import { useEffect } from 'react';

import { useViewerState } from '@zillow/shopper-platform-config';
import { page } from '@zillow/universal-analytics';
import {
    createUserSessionStore,
    getUserSessionStore,
    hasUserSessionStore,
    subscribeToUserSessionStore,
} from '@zillow/user-session-store';

import { getCookieValue } from '../../utils/cookie';

const HeadScripts: React.FC = () => {
    const { isLoggedIn } = useViewerState();

    useEffect(() => {
        const eventStartTime = new Date().toISOString();

        page(
            window.location.pathname,
            {},
            {
                newLaneEvent: {
                    // As defined in legacy homepage: https://gitlab.zgtools.net/zillow/searchxp/homepage-service/-/blob/a623921660cdbf01dcdfbf63e44cdd19a0eef931/homepage-service-content/src/utils/clickstreamEvents.js#L92-97
                    clickstream_trigger: {
                        trigger_location_nm: 'home',
                        trigger_type_nm: 'view',
                        trigger_object_nm: 'no_trigger_object',
                        trigger_source_nm: 'home',
                    },
                    // As defined in legacy homepage: https://gitlab.zgtools.net/zillow/searchxp/homepage-service/-/blob/a623921660cdbf01dcdfbf63e44cdd19a0eef931/homepage-service-content/src/utils/clickstreamEvents.js#L52-58
                    envelope: {
                        event_template_version_id: '1',
                        event_type_version_id: '1',
                        event_client_start_dtm: eventStartTime,
                        event_template_id: '9',
                        event_type_id: '43',
                    },
                    // As defined in legacy homepage: https://gitlab.zgtools.net/zillow/searchxp/homepage-service/-/blob/a623921660cdbf01dcdfbf63e44cdd19a0eef931/homepage-service-content/src/utils/clickstreamEvents.js#L139-142
                    semantic: {
                        topic_tag_txt: ['home'],
                        semantic_event_nm: 'view_content',
                    },
                },
                integrations: { All: false, GaPlugin: true },
            }
        );

        // susbscribe to log in event, as defined in legacy homepage: https://gitlab.zgtools.net/zillow/searchxp/homepage-service/-/blob/1daf105885df031f355f037686fe654fee9aab27/homepage-service-content/src/lazyComponents/LazyOneTapLogin.js#L62
        if (!hasUserSessionStore()) {
            createUserSessionStore();
        }

        subscribeToUserSessionStore((state) => {
            if (state.user.loggedIn) {
                window.location.reload();
            }
        });

        // eslint-disable-next-line max-len
        // eslint-disable-next-line zillow/@typescript-eslint/no-unsafe-assignment, zillow/@typescript-eslint/no-unsafe-member-access
        const dataDogRum = (window as any).DD_RUM;
        // eslint-disable-next-line zillow/@typescript-eslint/no-unsafe-member-access
        if (dataDogRum?.onReady && dataDogRum?.addError) {
            // eslint-disable-next-line max-len
            // eslint-disable-next-line zillow/@typescript-eslint/no-unsafe-member-access, zillow/@typescript-eslint/no-unsafe-call
            dataDogRum.onReady(async () => {
                const userSessionStoreState = getUserSessionStore().getState();
                if (userSessionStoreState.user.loggedIn !== isLoggedIn) {
                    const authReq = await fetch('/api/user/isAuthenticated');
                    // eslint-disable-next-line zillow/@typescript-eslint/no-unsafe-assignment
                    const authJson = await authReq.json();

                    // eslint-disable-next-line max-len
                    // eslint-disable-next-line zillow/@typescript-eslint/no-unsafe-member-access, zillow/@typescript-eslint/no-unsafe-call
                    dataDogRum.addError(new Error('User logged in state did not match'), {
                        clientSideValue: userSessionStoreState.user.loggedIn,
                        serverSideValue: isLoggedIn,
                        // eslint-disable-next-line max-len
                        // eslint-disable-next-line zillow/@typescript-eslint/no-unsafe-assignment, no-underscore-dangle
                        guid: window.__NEXT_DATA__.props.guid,
                        encodedZuid: getCookieValue('zjs_user_id'),
                        // eslint-disable-next-line max-len
                        // eslint-disable-next-line zillow/@typescript-eslint/no-unsafe-assignment, zillow/@typescript-eslint/no-unsafe-member-access
                        authEncodedZuid: authJson?.encodedZuid,
                    });
                }
            });
        }
    }, []);

    return null;
};

export default HeadScripts;
